import { createSlice } from "@reduxjs/toolkit"

// Check localStorage when app starts
const storedUser = JSON.parse(localStorage.getItem("user"))

const initialState = {
  user: storedUser,
  isLoggedIn: !!storedUser, // true if user exists in localStorage
}

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.user = action.payload
      state.isLoggedIn = true
      localStorage.setItem("user", JSON.stringify(action.payload)) // save to localStorage
    },
    logout: (state) => {
      state.user = null
      state.isLoggedIn = false
      localStorage.removeItem("user") // clear localStorage
    },
  },
})

export const { login, logout } = authSlice.actions
export default authSlice.reducer
